module.exports = __webpack_public_path__ + "static/media/about 275 330.8c0db8df.jpg";